import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import order from '../repositories/order';

const REQUEST_ORDER_PREORDER_PATH = '/order/preorder';
const REQUEST_ORDER_PATH = '/order';

type SuccessResponse = (res?: any) => void;
type ErrorResponse = (error: AxiosError<Response.Error>) => void;

const useOrder = (
  handleSuccess?: SuccessResponse,
  handleError?: ErrorResponse,
) => {
  const requestOrderPreorder = useMutation<
    AxiosResponse<{ item: string }>,
    AxiosError<Response.Error>,
    Payload.OrderPreorderReq
  >({
    mutationKey: [REQUEST_ORDER_PREORDER_PATH],
    mutationFn: (args) => {
      return order.requestOrderPreorder(REQUEST_ORDER_PREORDER_PATH, args);
    },
    onSuccess: (res) => {
      if (handleSuccess) {
        handleSuccess(res?.data?.item);
      }
    },
    onError: (error) => {
      if (handleError) {
        handleError(error);
      }
    },
  });

  const requestOrder = useMutation<
    AxiosResponse<{}>,
    AxiosError<Response.Error>,
    Payload.OrderReq
  >({
    mutationKey: [REQUEST_ORDER_PATH],
    mutationFn: (args) => {
      return order.requestOrder(REQUEST_ORDER_PATH, args);
    },
    onSuccess: (res) => {
      if (handleSuccess) {
        handleSuccess();
      }
    },
    onError: (error) => {
      if (handleError) {
        handleError(error);
      }
    },
  });

  return {
    requestOrder,
    requestOrderPreorder,
  };
};

export default useOrder;
